export const consentEventCategories = {
    hecMarketingEmail: ' Marketing Email',
    hecTextMessage: ' Text Message Notification',
    hecSaleEmail: ' Sale Email',
    hecEducationEmail: ' Education Email',
    fsaEasySpender: 'FSA Easy Spender Email'
}

export const pageCategories = {
    page: 'page',
    learningCenter: 'Learning Center'
}

export const sessionKeys = {
    identified: 'segment_user_identified',
    consentTracked: 'segment_consent_tracked'
}
